import { defineMessages } from 'react-intl';


const TabMessages = defineMessages({
    // messages for left side control menu
    MORTGAGE_LABEL: {
        id: 'Accounts.tabs.mortgage',
        defaultMessage: 'Mortgage',
    },
    AUTO_LABEL: {
        id: 'Accounts.tabs.autoInsurance',
        defaultMessage: 'Auto insurance',
    },
    HOME_LABEL: {
        id: 'Accounts.tabs.homeInsurance',
        defaultMessage: 'Home insurance',
    },
    CREDIT_CARD_LABEL: {
        id: 'Accounts.tabs.creditCard',
        defaultMessage: 'Credit Card',
    },

    // messages for right side panel
    WELCOME: {
        id: 'Accounts.MyAccountPage.welcomeBack',
        defaultMessage: `{hasUserName, select,
            true {Welcome back, {name}}
            other {Welcome back}
        }`,
    },
    DROPDOWN_LABEL: {
        id: 'Accounts.MyAccountPage.currentlyViewing',
        defaultMessage: 'Currently viewing',
    },

    MORTGAGE_TITLE: {
        id: 'Accounts.MyAccountPage.mortgage',
        defaultMessage: 'Mortgage',
    },
    INS_AUTO_TITLE: {
        id: 'Accounts.MyAccountPage.autoInsurance',
        defaultMessage: 'Auto insurance',
    },
    INS_HOME_TITLE: {
        id: 'Accounts.MyAccountPage.homeInsurance',
        defaultMessage: 'Home insurance',
    },

    START_APPLICATION_CTA: {
        id: 'Account.startApplicationCTA.startNewApplication',
        defaultMessage: 'Start new application',
    },
    START_QUOTE_CTA: {
        id: 'Account.startQuoteCTA.startNewQuote',
        defaultMessage: 'Start new quote',
    },
    START_NEW_SEARCH_CTA: {
        id: 'Account.startNewSearchCTA.startNewSearch',
        defaultMessage: 'Start new search',
    },

    MY_APPLICATIONS: {
        id: 'Accounts.headerTitle.myApplications',
        defaultMessage: 'My applications',
    },
    MY_QUOTES: {
        id: 'Accounts.headerTitle.myQuotes',
        defaultMessage: 'My quotes',
    },
    MY_CREDIT_CARD_SEARCHES: {
        id: 'Accounts.headerTitle.myCreditCardSearches',
        defaultMessage: 'My credit card searches',
    },
});

const TabValues = {
    MORTGAGE: 'mortgage',
    AUTO: 'auto',
    HOME: 'home',
    CREDIT_CARD: 'credit-card',
};

export {
    TabMessages,
    TabValues,
};
